export default {
    segmentReadAllBegin(state) {
        state.loading = true;
    },

    segmentReadAllSuccess(state, data) {
        state.loading = false;
        state.data = data.list !== undefined ? data.list : [];
        state.totalRecords = data.total !== undefined ? data.total : 0;
    },

    segmentAddBegin(state) {
        state.loading = true;
    },

    segmentAddSuccess(state) {
        state.loading = false;
    },
};